import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import MutationManagementTeamRights from 'graphql/mutations/management/MutationManagementTeamRights'

export default class MutateTeamRights {
	
	static log( value ) {
		console.prefix('MutateTeamRights', value );
	}
	
	static mutate = ( buildingGuid, floorGuid, roomGuid, teamGuids, { callbackSuccess = null, callbackError = null, callbackStart = null, table = null, guid = null } = {} ) => {
		
		const builder = new GraphqlBuilder();
		builder.addQuery( 'mutation_team_rights', MutationManagementTeamRights, {
			building_guid: buildingGuid,
			floor_guid: floorGuid,
			room_guid: roomGuid,
			team_guid: _.isArray( teamGuids ) ? teamGuids : [ teamGuids ]
		})
		
		builder.setOnStart( callbackStart )
		
		builder.setOnSuccess( ( result ) => {
			this.onSuccess( result, callbackSuccess );
		});
		
		builder.setOnError( (result) => {
			this.onSuccess( result, callbackError );
		} );
		
		if( builder.queries.length > 0 ) {
			builder.execute();
			return;
		}
		
		this.onSuccess( {}, callbackSuccess );
	}
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onSuccess = ( result, callback ) => {
		const timeslots = [];
		_.forEach( result, o => {
			timeslots.push( o.timeslot );
		})
		
		if( _.isFunction( callback ) ) {
			callback( timeslots );
		}
	}
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onError = ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	}
}
